import styled from 'styled-components';

const HomeWrapper = styled.div`
    .home-container {
        height:100vh;
        max-height: 100vh;
        overflow: hidden;
        padding: 20px;
    }
`;
export default HomeWrapper;


// WEBPACK FOOTER //
// ./src/components/Home/Home.style.js